module.exports = __webpack_public_path__ + "static/img/home-choose.e920fef4.png";